export const summerThemeCss = `
	/* Meeting page: add padding and border to header and editor so they
	   don't run edge-to-edge against the beach background */
	.summer-theme [data-component="meeting-header"] {
		padding: var(--chakra-space-3);
		border: 1px solid var(--chakra-colors-border-default);
	}
	.summer-theme [data-component="one-on-one-view"] :has(> .shared-editor-container) {
		border-radius: var(--chakra-radii-lg);
		overflow: hidden;
	}
	.summer-theme [data-component="one-on-one-view"] .shared-editor-container {
		padding: var(--chakra-space-3);
		border: 1px solid var(--chakra-colors-border-default);
		border-radius: var(--chakra-radii-lg);
	}
	.summer-theme [data-component="one-on-one-view"] [data-component="completed-meeting-view"] {
		padding: var(--chakra-space-3);
		border: 1px solid var(--chakra-colors-border-default);
	}

	/* Bizy side panel: frosted surface so messages stay readable over the
	   beach background. */
	.summer-theme [data-component="bizy-side-panel"] {
		background: var(--chakra-colors-whiteAlpha-900) !important;
		backdrop-filter: blur(44px);
		-webkit-backdrop-filter: blur(44px);
	}
	html[data-theme="dark"].summer-theme [data-component="bizy-side-panel"] {
		background: var(--chakra-colors-blackAlpha-900) !important;
	}

	/* Meeting context drawer (fob + expanded panel) and the header dropdown
	   panel (History / Info): frosted surface so content stays readable over
	   the beach. */
	.summer-theme [data-component="meeting-context-drawer-fob"],
	.summer-theme [data-component="meeting-context-drawer-panel"],
	.summer-theme [data-component="meeting-header-dropdown-panel"] {
		background: var(--chakra-colors-whiteAlpha-900) !important;
		backdrop-filter: blur(44px);
		-webkit-backdrop-filter: blur(44px);
	}
	html[data-theme="dark"].summer-theme [data-component="meeting-context-drawer-fob"],
	html[data-theme="dark"].summer-theme [data-component="meeting-context-drawer-panel"],
	html[data-theme="dark"].summer-theme [data-component="meeting-header-dropdown-panel"] {
		background: var(--chakra-colors-blackAlpha-900) !important;
	}

	/* Scroll-fade gradients inside the frosted panels use bg-canvas as the
	   opaque end of the gradient. In summer dark mode bg-canvas is transparent,
	   so the fade disappears. Override to match the frosted panel surface. */
	.summer-theme [data-component="context-drawer-scroll-fade"] {
		background: linear-gradient(to bottom, var(--chakra-colors-whiteAlpha-900) 0%, transparent 100%) !important;
	}
	html[data-theme="dark"].summer-theme [data-component="context-drawer-scroll-fade"] {
		background: linear-gradient(to bottom, var(--chakra-colors-blackAlpha-900) 0%, transparent 100%) !important;
	}

	/* Styling for Menu lists (main and submenus) in Summer Theme */
	.summer-theme .chakra-menu__menu-list {
		background: var(--chakra-colors-whiteAlpha-900) !important;
		backdrop-filter: blur(44px) !important;
		-webkit-backdrop-filter: blur(44px) !important;
		border-color: var(--chakra-colors-border-default) !important;
	}
	html[data-theme="dark"].summer-theme .chakra-menu__menu-list {
		background: var(--chakra-colors-blackAlpha-900) !important;
		border-color: var(--chakra-colors-border-default) !important;
	}

	/* Hover/Focus/Active styles for Menu items in Summer Theme */
	.summer-theme .chakra-menu__menu-item {
		border-radius: var(--chakra-radii-md) !important;
		transition: background 0.15s ease, color 0.15s ease !important;
	}
	.summer-theme .chakra-menu__menu-item:hover,
	.summer-theme .chakra-menu__menu-item:focus,
	.summer-theme .chakra-menu__menu-item[data-active] {
		background: var(--chakra-colors-primary-bgAlpha) !important;
		color: var(--chakra-colors-primary-fgStrong) !important;
	}

	/* Styling for expanded nav menu buttons in Summer Theme */
	.summer-theme [data-testid="user-nav-menu-button"][aria-expanded="true"] {
		background: var(--chakra-colors-primary-bgAlpha) !important;
		color: var(--chakra-colors-primary-fgStrong) !important;
	}
	.summer-theme [data-testid="user-nav-menu-button"][aria-expanded="true"] * {
		color: var(--chakra-colors-primary-fgStrong) !important;
	}
`;
